import React from 'react'
import { Modal, ModalHeader } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'
import { Trans } from 'react-i18next'
import { RESALE_DETAILS_LINKS } from 'utils/constants'

interface ModalResalePlanExplanationProps {
  open: boolean
  isLarge: boolean
  onClose: () => void
}

const ModalResalePlanExplanation: React.FC<ModalResalePlanExplanationProps> = ({
  open,
  isLarge,
  onClose,
}) => {
  const { t, i18n } = useTranslation()
  const resaleDetailsLink =
    RESALE_DETAILS_LINKS[i18n.language] ?? RESALE_DETAILS_LINKS.ja
  return (
    <Modal
      position={isLarge ? 'middle' : 'bottom'}
      open={open}
      onClose={onClose}
      containerClassName="!pt-0 !px-0 !pb-0 !w-full !h-full !text-left"
    >
      <div className="max-h-[85%] lg:!max-h-full flex flex-col bg-white shadow-xl transform transition-all lg:align-middle w-full lg:h-auto rounded-t-2.5xl lg:rounded-t-none lg:w-[680px]">
        <div className="p-6 border-b border-gray-150">
          <ModalHeader
            labelClassName="font-bold"
            onClose={onClose}
            label={t('Resale Service Modal Title')}
          />
        </div>

        <div className="p-6 overflow-y-auto">
          <div className="space-y-4 text-sm leading-relaxed">
            <p>{t('Resale Service Modal Description')}</p>
            <p>
              <Trans
                i18nKey="Please refer to <1>this page</1> for details."
                components={{
                  1: (
                    <a
                      key="resale-details-link"
                      href={resaleDetailsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline text-primary"
                      tabIndex={-1}
                    />
                  ),
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ModalResalePlanExplanation.displayName = 'ModalResalePlanExplanation'

export default ModalResalePlanExplanation
